import React, { useEffect, useImperativeHandle, useRef, useState } from "react";
import { Box } from '@curves/ui-base';

import * as echarts from "echarts/core";
import { BarChart } from "echarts/charts";
import { GridComponent, TooltipComponent, LegendComponent, DatasetComponent } from "echarts/components";
import { CanvasRenderer } from "echarts/renderers";
import { isEmpty } from "@Util/utils";
import { chartColorMap } from "@Local/Dashboard/staticData";
echarts.use([BarChart, DatasetComponent, GridComponent, TooltipComponent, LegendComponent, CanvasRenderer]);
const TotalBarChartBox = React.forwardRef((props, ref) => {
        const {
            tooltip = { trigger: 'axis' },
            grid = { left: "5%", right: "3%" },
            xAxis = { type: 'category' },
            yAxis = { type: 'value' },
            style,
            others = {},
            dark: darkProps,
            showPercent = false,
        } = props;
        let option = {
            color: chartColorMap,
            legend: {},
            tooltip,
            grid,
            dataset: { source: [] },
            xAxis,
            yAxis,
            series: [],
            ...others,
        };
        const [chartInstance, setChartInstance] = useState(null);
        const [sourceData, setSourceData] = useState(null);
        const chartRef = useRef(null);
        useImperativeHandle(ref, () => ({
            setSource: (source) => {
                setSourceData(source);
            },
            triggerResize: (width, height) => {
                chartRef.current.style.width = width;
                chartRef.current.style.height = height;
                if (chartInstance) {
                    chartInstance.resize(); // 根據容器大小自適應
                }
            }
        }));
        useEffect(
            () => {
                if (!chartInstance || isEmpty(sourceData)) return;
                chartInstance.clear();
                const seriesResult = []
                let index = 1;
                if (!showPercent) {
                    option.dataset.source = sourceData;
                    while (index < sourceData[0].length) {
                        seriesResult.push({
                            type: 'bar',
                            stack: 'total',
                            name: sourceData[0][index],
                            encode: { x: 'category', y: sourceData[0][index] },
                            label: {
                                show: true
                            }
                        });
                        index++;
                    }
                } else {
                    let pos = 1;
                    const totalSet = [];
                    const percentageSet = []
                    const xAxisSet = [];
                    while (pos < sourceData.length) {
                        let total = 0;
                        sourceData[pos].forEach((item, i) => {
                                if (i > 0) total += Number(item);
                            }
                        )
                        totalSet.push(total);
                        xAxisSet.push(sourceData[pos][0]);
                        pos++;
                    }
                    option.xAxis.data = xAxisSet;
                    while (index < sourceData[0].length) {
                        pos = 1;
                        const data = [];
                        while (pos < sourceData.length) {
                            if (index + 1 === sourceData[0].length) {
                                const value = (percentageSet[pos - 1]).toFixed(1);
                                data.push(value);
                            } else {
                                const value = ((Number(sourceData[pos][index]) / totalSet[pos - 1]) * 100).toFixed(1);
                                data.push(value);
                                percentageSet[pos - 1] = (percentageSet[pos - 1] ?? 100) - value;
                            }
                            pos++;
                        }
                        seriesResult.push({
                            type: 'bar',
                            stack: 'total',
                            name: sourceData[0][index],
                            label: {
                                show: true,
                                position: 'inside',
                                formatter: (params) => `${params.value}%`
                            },
                            data
                        });
                        index++;
                    }
                }
                option.series = seriesResult;
                // console.log(JSON.stringify(option));
                chartInstance.setOption(option);
            },
            // eslint-disable-next-line
            [chartInstance, sourceData, showPercent]
        );
        useEffect(
            () => {
                if (!chartRef.current) return;
                const instance = echarts.init(chartRef.current, darkProps ? "dark" : "light");
                setChartInstance(instance);
                return () => {
                    instance.dispose();
                };
            },
            // eslint-disable-next-line
            []
        );
        return <Box ref={chartRef} style={style}></Box>;
    })
;
export default TotalBarChartBox;